export default __webpack_public_path__ + "src/images/packages/safari-moon-lodge/3c185e045518246b87a1841fe5ace6d9-1.jpg";